import React, { useState } from "react";
import {
  Button,
  Card,
  Header,
  Image,
  Modal,
  Segment,
  Grid,
} from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import StockRadarChart from "./StockRadarChart";
import PerformanceRadarChart from "./PerformanceRadarChart";
import CompanyPage from "../company/CompanyPage";
import { useMobile } from "../MobileContext";
import Constants from "../util/Constants";

const ScreenerCombinedView = (props) => {
  const isMobile = useMobile().isMobile;

  const sr = props.stockReports
    ? !props.displayAll
      ? props.stockReports.slice(0, 50)
      : props.stockReports
    : null;

  const [modalState, setModalState] = useState({
    open: false,
    modalSymbol: "",
  });

  const handleShowModal = (symbol) => {
    setModalState({ ...modalState, modalSymbol: symbol, open: true });
  };

  const handleCloseModal = () => {
    setModalState({ ...modalState, open: false });
  };

  return (
    <div
      id="combined-view"
      style={{
        minHeight: "74vh",
        padding: "1rem",
        marginBottom: "56px",
        backgroundColor: "#f8f9fa",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: isMobile ? "100vw" : "none",
        overflowX: "hidden",
      }}
    >
      {!props.displayAll && (
        <Header
          as="h4"
          textAlign="center"
          style={{
            marginBottom: "1rem",
            color: "#2c3e50",
            fontWeight: "500",
            fontSize: "1rem",
            width: "100%",
          }}
        >
          Note: Only top 50 are shown below
        </Header>
      )}

      <Grid
        stackable
        columns={isMobile ? 1 : 3}
        style={{
          width: isMobile ? "90%" : "95%",
          margin: "0 auto",
          maxWidth: "1400px",
        }}
      >
        {sr &&
          sr.map((stock) => (
            <Grid.Column
              key={stock.symbol}
              mobile={16}
              tablet={8}
              computer={5}
              largeScreen={5}
              widescreen={5}
              style={{
                padding: "0.75rem",
              }}
            >
              <Card
                raised
                style={{
                  ...cardStyle,
                  width: "100%",
                  margin: 0,
                }}
                onClick={() => handleShowModal(stock.symbol)}
                className="stock-card"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow = `
                    0 20px 40px rgba(102, 126, 234, 0.3),
                    0 10px 20px rgba(118, 75, 162, 0.25),
                    0 0 0 1px rgba(255, 255, 255, 0.25),
                    inset 0 1px 0 rgba(255, 255, 255, 0.4),
                    0 0 40px rgba(79, 172, 254, 0.25)
                  `;
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
                  e.currentTarget.style.background = "linear-gradient(135deg, #764ba2 0%, #667eea 30%, #4facfe 70%, #667eea 100%)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = `
                    0 8px 16px rgba(102, 126, 234, 0.2),
                    0 4px 8px rgba(118, 75, 162, 0.15),
                    0 0 0 1px rgba(255, 255, 255, 0.15),
                    inset 0 1px 0 rgba(255, 255, 255, 0.25),
                    inset 0 -1px 0 rgba(0, 0, 0, 0.1)
                  `;
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.25)";
                  e.currentTarget.style.background = "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #4facfe 100%)";
                }}
              >
                <Card.Content style={{ padding: "0.6rem 0.75rem 0.25rem 0.75rem" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Image
                      size="mini"
                      src={stock.image || `${Constants.IMAGE_URL}${stock.symbol}.jpg`}
                      rounded
                      style={{ margin: 0, flexShrink: 0 }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div style={{ textAlign: "right", flex: 1, marginLeft: "0.5rem" }}>
                      <Card.Header style={headerStyle}>
                        {stock.symbol}
                      </Card.Header>
                      <Card.Meta style={metaStyle}>
                        ${stock.price}
                      </Card.Meta>
                    </div>
                  </div>
                </Card.Content>
                <Card.Description style={{ padding: "0.2rem 0.75rem 0.6rem 0.75rem" }}>
                  <div style={chartsContainerStyle}>
                    {/* Fundamentals Chart - Left Side */}
                    <div style={chartWrapperStyle}>
                      <div style={chartLabelStyle}>
                        <span style={labelTextStyle}>Fundamentals</span>
                      </div>
                      <Segment basic style={fundamentalsSegmentStyle}>
                        <StockRadarChart
                          scoreData={stock}
                          width={140}
                          height={105}
                          labelSize="short"
                          darkBackground={false}
                        />
                      </Segment>
                    </div>
                    {/* Technical Chart - Right Side */}
                    <div style={chartWrapperStyle}>
                      <div style={chartLabelStyle}>
                        <span style={labelTextStyle}>Technicals</span>
                      </div>
                      <Segment basic style={technicalSegmentStyle}>
                        <PerformanceRadarChart
                          performanceData={stock}
                          width={160}
                          height={120}
                          labelSize="short"
                        />
                      </Segment>
                    </div>
                  </div>
                </Card.Description>
              </Card>
            </Grid.Column>
          ))}
      </Grid>

      <Modal
        closeOnEscape
        centered
        open={modalState.open}
        onClose={handleCloseModal}
        size="fullscreen"
        style={{
          marginLeft: "2%",
          backgroundColor: "rgba(0,0,0,0.85)",
        }}
      >
        <Modal.Content scrolling style={{ padding: "1rem" }}>
          <Modal.Description>
            <CompanyPage symbol={modalState.modalSymbol} />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions style={{ padding: "1rem" }}>
          <Button primary onClick={handleCloseModal} style={buttonStyle}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

// Card styles - using an enhanced background with 3D look
const cardStyle = {
  background: "linear-gradient(to bottom, #1e3a5f 0%, #0f1f3d 100%)",
  color: "#333",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
  minHeight: "260px",
  borderRadius: "16px",
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  cursor: "pointer",
  boxShadow: `
    0 8px 16px rgba(102, 126, 234, 0.2),
    0 4px 8px rgba(118, 75, 162, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.25),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1)
  `,
  border: "1px solid rgba(255, 255, 255, 0.25)",
  borderTop: "1px solid rgba(255, 255, 255, 0.35)",
  overflow: "hidden",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "1px",
    background: "linear-gradient(to right, transparent, rgba(255, 255, 255, 0.5), transparent)",
    zIndex: 1,
  },
};

const headerStyle = {
  color: "#ffffff",
  fontWeight: "700",
  fontSize: "1.15rem",
  letterSpacing: "0.3px",
  margin: 0,
  lineHeight: 1.2,
  textShadow: "0 2px 4px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2)",
};

const metaStyle = {
  color: "rgba(255, 255, 255, 0.9)",
  fontWeight: "600",
  fontSize: "0.95rem",
  marginTop: "0.15rem",
  marginBottom: 0,
  lineHeight: 1.2,
  textShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
};

// Container for both charts side by side
const chartsContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "0.5rem",
  width: "100%",
};

// Chart wrapper - contains label and chart segment
const chartWrapperStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: 0, // Prevents flex item from overflowing
};

// Fundamentals chart segment (left side)
const fundamentalsSegmentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "140px",
  height: "140px",
  padding: "0.3rem 0.4rem",
  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.9) 100%)",
  borderRadius: "10px",
  margin: 0,
  marginTop: "0.25rem",
  border: "1px solid rgba(255, 255, 255, 0.4)",
  borderTop: "1px solid rgba(255, 255, 255, 0.6)",
  boxShadow: `
    inset 0 2px 4px rgba(0, 0, 0, 0.1),
    inset 0 -1px 2px rgba(255, 255, 255, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.1)
  `,
  position: "relative",
  backdropFilter: "blur(10px)",
  width: "100%",
  boxSizing: "border-box",
};

// Technical chart segment (right side)
const technicalSegmentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "140px",
  height: "140px",
  padding: "0.3rem 0.4rem",
  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.9) 100%)",
  borderRadius: "10px",
  margin: 0,
  marginTop: "0.25rem",
  border: "1px solid rgba(255, 255, 255, 0.4)",
  borderTop: "1px solid rgba(255, 255, 255, 0.6)",
  boxShadow: `
    inset 0 2px 4px rgba(0, 0, 0, 0.1),
    inset 0 -1px 2px rgba(255, 255, 255, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.1)
  `,
  position: "relative",
  backdropFilter: "blur(10px)",
  width: "100%",
  boxSizing: "border-box",
};

// Chart label styling - now positioned above the chart
const chartLabelStyle = {
  width: "100%",
  textAlign: "center",
  marginBottom: "0.25rem",
};

const labelTextStyle = {
  fontSize: "0.75rem",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "0.15rem 0.5rem",
  borderRadius: "6px",
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  display: "inline-block",
};

const buttonStyle = {
  backgroundColor: "#3498db",
  color: "white",
  padding: "0.6rem 1.5rem",
  borderRadius: "6px",
  border: "none",
  fontWeight: "500",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#2980b9",
    transform: "scale(1.02)",
  },
};

export default ScreenerCombinedView;
